var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"svg-container",attrs:{"id":`${_vm.chartData.id}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }